// La moneda del anuncio: una sola para el anuncio, sus alojamientos y sus tarifas.
export const monedaAnuncio = {
  chipTitle: "Waluta ogłoszenia",
  change: "Zmień",
  mismatchDot: "Waluty tego ogłoszenia się nie zgadzają",
  channexText: "To ogłoszenie jest połączone z Channex. Tam nie można zmienić waluty taryfy: trzeba ją utworzyć od nowa. Napisz do nas, a zrobimy to bez przerywania sprzedaży w OTA.",
  channexOnly: "Jest połączone z Channex: może używać tylko {currency}, waluty swoich taryf tam.",
  modal: {
    title: "Waluta ogłoszenia",
    lead: "W tej walucie pobierasz płatności od gości tego ogłoszenia.",
    scope: "Zmienia się jednocześnie dla ogłoszenia, wszystkich jego obiektów i taryf. Linki płatności, agent AI i późne wymeldowanie będą używać tej waluty.",
    label: "Waluta",
    mismatch: "Obecnie się nie zgadzają: ogłoszenie ma {listing}, a jego obiekty pobierają w {units}. Po zapisaniu wszystko będzie w jednej.",
    channexTitle: "Nie można zmienić tutaj",
    cancel: "Anuluj",
    close: "Rozumiem",
    save: "Zapisz",
    saving: "Zapisywanie…",
    saved: "Waluta ogłoszenia zmieniona na {currency}.",
    error: "Nie udało się zmienić waluty. Spróbuj ponownie.",
  },
  sugerencia: {
    titleCountry: "To ogłoszenie pobiera w {current}",
    textCountry: "W kraju {country} zwykle płaci się w {suggested}. Jeśli ją zmienisz, linki płatności, agent AI i późne wymeldowanie będą używać {suggested}.",
    titleMismatch: "Waluty tego ogłoszenia się nie zgadzają",
    textMismatch: "Ogłoszenie ma {listing}, a jego obiekty pobierają w {units}. Zostaw jedną, aby to, co podaje AI, i to, co się pobiera, było tym samym.",
    useSuggested: "Zmień na {currency}",
    other: "Wybierz inną",
    keep: "Zostaw {currency}",
  },
};
